import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { memo } from 'react';
import { stepNumberInput } from '../../../utils/numberScrub';

/**
 * The ‹ › step arrows of a number field (Blender-style, shown on hover — see
 * `.number-field` in index.css). Place them inside the `.number-field` wrapper
 * next to its input — they step that input; Shift steps a tenth, Ctrl ten steps.
 */
const step = (direction: 1 | -1) => (e: React.MouseEvent<HTMLButtonElement>) => {
  const input = e.currentTarget.parentElement?.querySelector('input');
  if (input) stepNumberInput(input, direction, { fine: e.shiftKey, coarse: e.ctrlKey || e.metaKey });
};

const NumberStepArrows_: React.FC = () => {
  return (
    <>
      {/* Pointer-down kept from focusing anything: the arrow acts on click only. */}
      <button type="button" tabIndex={-1} aria-hidden className="number-field-arrow number-field-arrow-left" onPointerDown={(e) => e.preventDefault()} onClick={step(-1)}>
        <ChevronLeftIcon className="h-3 w-3" strokeWidth={2.5} />
      </button>
      <button type="button" tabIndex={-1} aria-hidden className="number-field-arrow number-field-arrow-right" onPointerDown={(e) => e.preventDefault()} onClick={step(1)}>
        <ChevronRightIcon className="h-3 w-3" strokeWidth={2.5} />
      </button>
    </>
  );
};

export const NumberStepArrows = memo(NumberStepArrows_);
